interface LogoProps {
  className?: string;
}

/**
 * Canonical Opinix wordmark — the 600x180 PNG used on the Pi boot splash.
 * Render at h-8 (or sized via className) with auto width to preserve aspect.
 * The wordmark already includes the "OPINIX" lockup, so we don't render a
 * separate text label next to it.
 */
export function Logo({ className = '' }: LogoProps): JSX.Element {
  return (
    <a
      href="/"
      className={`inline-flex items-center ${className}`}
      aria-label="Opinix home"
    >
      <img
        src="/opinix-wordmark.png"
        alt="Opinix"
        width={600}
        height={180}
        className="h-8 w-auto"
      />
    </a>
  );
}
